import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const POSITION_LABELS: Record<string, string> = {
  guard: 'Харуул', cleaner: 'Цэвэрлэгч', electrician: 'Цахилгаанчин',
  plumber: 'Сантехникч', janitor: 'Жижүүр', accountant: 'Нягтлан',
  maintenance: 'Засварчин', other: 'Бусад',
};

const METHOD_LABELS: Record<string, string> = { bank_transfer: 'Банк шилжүүлэг', cash: 'Бэлнээр' };
const STATUS_LABELS: Record<string, string> = { pending: 'Хүлээгдэж буй', paid: 'Олгосон', cancelled: 'Цуцалсан' };

export default function EmployeesPage() {
  const [activeTab, setActiveTab] = useState<'employees' | 'payroll'>('employees');

  const tabs = [
    { key: 'employees' as const, label: 'Ажилчид' },
    { key: 'payroll' as const, label: 'Цалин олголт' },
  ];

  return (
    <div>
      <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22', marginBottom: 20 }}>Ажилчдын удирдлага</h2>

      <div style={{ display: 'flex', gap: 4, marginBottom: 24, borderBottom: '2px solid #e8e5dc' }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setActiveTab(t.key)} style={{
            padding: '10px 20px', border: 'none', cursor: 'pointer', fontSize: 14,
            fontWeight: activeTab === t.key ? 600 : 400,
            color: activeTab === t.key ? '#236844' : '#5f6f66',
            background: 'transparent',
            borderBottom: activeTab === t.key ? '2px solid #236844' : '2px solid transparent',
            marginBottom: -2,
          }}>{t.label}</button>
        ))}
      </div>

      {activeTab === 'employees' && <EmployeesTab />}
      {activeTab === 'payroll' && <PayrollTab />}
    </div>
  );
}

/* ======================== EMPLOYEES TAB ======================== */
function EmployeesTab() {
  const [employees, setEmployees] = useState<any[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [showAll, setShowAll] = useState(false);
  const [form, setForm] = useState({
    first_name: '', last_name: '', register_number: '', phone: '', position: 'other',
    position_title: '', salary: '', start_date: '', notes: '',
  });

  const load = () => {
    const activeParam = showAll ? 'active_only=false' : 'active_only=true';
    Promise.all([
      api.get(`/admin/employees?${activeParam}&limit=100`).then(res => setEmployees(res?.items || [])).catch(() => {}),
      api.get('/admin/employees/stats/summary').then(res => setStats(res)).catch(() => {}),
    ]).finally(() => setLoading(false));
  };

  useEffect(load, [showAll]);

  const resetForm = () => {
    setForm({ first_name: '', last_name: '', register_number: '', phone: '', position: 'other', position_title: '', salary: '', start_date: '', notes: '' });
    setEditId(null);
    setShowForm(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const payload = { ...form, salary: Number(form.salary) || 0 };
    if (editId) {
      await api.put(`/admin/employees/${editId}`, payload);
    } else {
      await api.post('/admin/employees', payload);
    }
    resetForm();
    load();
  };

  const startEdit = (emp: any) => {
    setForm({
      first_name: emp.first_name, last_name: emp.last_name || '', register_number: emp.register_number || '',
      phone: emp.phone || '', position: emp.position, position_title: emp.position_title || '',
      salary: String(emp.salary || ''), start_date: emp.start_date || '', notes: emp.notes || '',
    });
    setEditId(emp.id);
    setShowForm(true);
  };

  const toggleActive = async (emp: any) => {
    if (emp.is_active) {
      await api.delete(`/admin/employees/${emp.id}`);
    } else {
      await api.put(`/admin/employees/${emp.id}`, { is_active: true });
    }
    load();
  };

  const formatSalary = (n: number) => n ? n.toLocaleString() + '₮' : '-';

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <button onClick={() => { setShowForm(!showForm); if (showForm) resetForm(); }} style={btnPrimary}>
          {showForm ? 'Болих' : '+ Шинэ ажилтан'}
        </button>
      </div>

      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 20 }}>
          {[
            { label: 'Нийт ажилтан', value: stats.total, color: '#1c2b22' },
            { label: 'Идэвхтэй', value: stats.active, color: '#16a34a' },
            { label: 'Идэвхгүй', value: stats.inactive, color: '#dc2626' },
            { label: 'Сарын цалингийн нийлбэр', value: formatSalary(stats.total_monthly_salary), color: '#236844' },
          ].map(s => (
            <div key={s.label} style={statCard}>
              <div style={{ fontSize: 12, color: '#5f6f66', marginBottom: 4 }}>{s.label}</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: s.color }}>{s.value}</div>
            </div>
          ))}
        </div>
      )}

      {showForm && (
        <div style={card}>
          <h3 style={{ marginBottom: 16, fontSize: 16 }}>{editId ? 'Ажилтан засах' : 'Шинэ ажилтан'}</h3>
          <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
            <div>
              <label style={labelStyle}>Нэр *</label>
              <input value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} style={inputStyle} required />
            </div>
            <div>
              <label style={labelStyle}>Овог</label>
              <input value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Регистрийн дугаар</label>
              <input value={form.register_number} onChange={e => setForm({ ...form, register_number: e.target.value })} style={inputStyle} placeholder="АА00112233" maxLength={10} />
            </div>
            <div>
              <label style={labelStyle}>Утас</label>
              <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Албан тушаал</label>
              <select value={form.position} onChange={e => setForm({ ...form, position: e.target.value })} style={inputStyle}>
                {Object.entries(POSITION_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Тодорхой нэр</label>
              <input value={form.position_title} onChange={e => setForm({ ...form, position_title: e.target.value })} style={inputStyle} placeholder="Жнь: Ахлах харуул" />
            </div>
            <div>
              <label style={labelStyle}>Цалин (₮)</label>
              <input type="number" value={form.salary} onChange={e => setForm({ ...form, salary: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Ажилд орсон огноо</label>
              <input type="date" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ gridColumn: 'span 2' }}>
              <label style={labelStyle}>Тэмдэглэл</label>
              <input value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} style={inputStyle} />
            </div>
            <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 8 }}>
              <button type="submit" style={btnPrimary}>{editId ? 'Хадгалах' : 'Бүртгэх'}</button>
              {editId && <button type="button" onClick={resetForm} style={btnSecondary}>Болих</button>}
            </div>
          </form>
        </div>
      )}

      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3>Ажилчид ({employees.length})</h3>
          <label style={{ fontSize: 13, color: '#5f6f66', display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={showAll} onChange={e => setShowAll(e.target.checked)} />
            Идэвхгүйг харуулах
          </label>
        </div>
        {loading ? <p>Уншиж байна...</p> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                <th style={th}>Нэр</th>
                <th style={th}>Регистр</th>
                <th style={th}>Утас</th>
                <th style={th}>Албан тушаал</th>
                <th style={th}>Цалин</th>
                <th style={th}>Ажилд орсон</th>
                <th style={th}>Статус</th>
                <th style={th}>Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((e: any) => (
                <tr key={e.id} style={{ borderBottom: '1px solid #e8e5dc', opacity: e.is_active ? 1 : 0.5 }}>
                  <td style={td}>{e.first_name} {e.last_name}</td>
                  <td style={td}>{e.register_number || '-'}</td>
                  <td style={td}>{e.phone || '-'}</td>
                  <td style={td}>
                    <span style={{ background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>
                      {POSITION_LABELS[e.position] || e.position}
                    </span>
                    {e.position_title && <span style={{ marginLeft: 6, fontSize: 12, color: '#5f6f66' }}>{e.position_title}</span>}
                  </td>
                  <td style={td}>{formatSalary(e.salary)}</td>
                  <td style={td}>{e.start_date || '-'}</td>
                  <td style={td}>
                    <span style={{
                      background: e.is_active ? '#dcfce7' : '#fee2e2',
                      color: e.is_active ? '#16a34a' : '#dc2626',
                      padding: '2px 8px', borderRadius: 4, fontSize: 12,
                    }}>{e.is_active ? 'Идэвхтэй' : 'Идэвхгүй'}</span>
                  </td>
                  <td style={td}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button onClick={() => startEdit(e)} style={btnSmall}>Засах</button>
                      <button onClick={() => toggleActive(e)} style={{
                        ...btnSmall,
                        background: e.is_active ? '#fee2e2' : '#dcfce7',
                        color: e.is_active ? '#dc2626' : '#16a34a',
                      }}>{e.is_active ? 'Идэвхгүй' : 'Идэвхжүүлэх'}</button>
                    </div>
                  </td>
                </tr>
              ))}
              {employees.length === 0 && (
                <tr><td colSpan={7} style={{ ...td, textAlign: 'center', color: '#999' }}>Ажилтан бүртгэгдээгүй байна</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

/* ======================== PAYROLL TAB ======================== */
function PayrollTab() {
  const now = new Date();
  const defaultPeriod = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const [period, setPeriod] = useState(defaultPeriod);
  const [payrolls, setPayrolls] = useState<any[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [editForm, setEditForm] = useState({ bonus: '', deduction: '', notes: '' });

  const load = () => {
    setLoading(true);
    Promise.all([
      api.get(`/admin/payroll?period=${period}&limit=100`).then(res => setPayrolls(res?.items || [])).catch(() => {}),
      api.get(`/admin/payroll/stats?period=${period}`).then(res => setStats(res)).catch(() => {}),
    ]).finally(() => setLoading(false));
  };

  useEffect(load, [period]);

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      await api.post('/admin/payroll/generate', { period });
      load();
    } catch {}
    setGenerating(false);
  };

  const handleBulkPay = async (method: string) => {
    await api.post(`/admin/payroll/pay-bulk?period=${period}&payment_method=${method}`);
    load();
  };

  const handlePay = async (id: string, method: string) => {
    await api.post(`/admin/payroll/${id}/pay`, { payment_method: method });
    load();
  };

  const handleUnpay = async (id: string) => {
    if (!window.confirm('«Цалин олгосон» тэмдэглэгээг буцаах уу? Төлөв «Хүлээгдэж буй» болно.')) return;
    try { await api.post(`/admin/payroll/${id}/unpay`); load(); } catch (e: any) { alert('Буцаахад алдаа: ' + (e?.message || '')); }
  };
  const handleCancel = async (id: string) => {
    await api.delete(`/admin/payroll/${id}`);
    load();
  };

  const startEdit = (pr: any) => {
    setEditId(pr.id);
    setEditForm({ bonus: String(pr.bonus || ''), deduction: String(pr.deduction || ''), notes: pr.notes || '' });
  };

  const handleEditSave = async () => {
    if (!editId) return;
    await api.put(`/admin/payroll/${editId}`, {
      bonus: Number(editForm.bonus) || 0,
      deduction: Number(editForm.deduction) || 0,
      notes: editForm.notes,
    });
    setEditId(null);
    load();
  };

  const fmt = (n: number) => n ? n.toLocaleString() + '₮' : '0₮';
  const pendingList = payrolls.filter(p => p.status === 'pending');

  return (
    <>
      {/* Period selector & actions */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 20 }}>
        <div>
          <label style={{ ...labelStyle, marginBottom: 0, marginRight: 8 }}>Сар:</label>
          <input type="month" value={period} onChange={e => setPeriod(e.target.value)} style={{ ...inputStyle, width: 160 }} />
        </div>
        <button onClick={handleGenerate} disabled={generating} style={btnPrimary}>
          {generating ? 'Үүсгэж байна...' : 'Цалин үүсгэх'}
        </button>
        {pendingList.length > 0 && (
          <>
            <button onClick={() => handleBulkPay('bank_transfer')} style={btnSecondary}>
              Бүгдийг банкаар олгох ({pendingList.length})
            </button>
            <button onClick={() => handleBulkPay('cash')} style={btnSecondary}>
              Бүгдийг бэлнээр олгох
            </button>
          </>
        )}
      </div>

      {/* Stats */}
      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 20 }}>
          <div style={statCard}>
            <div style={{ fontSize: 12, color: '#5f6f66', marginBottom: 4 }}>Нийт бүртгэл</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#1c2b22' }}>{stats.total_records}</div>
          </div>
          <div style={statCard}>
            <div style={{ fontSize: 12, color: '#5f6f66', marginBottom: 4 }}>Олгоогүй</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#dc2626' }}>{stats.pending_count} ({fmt(stats.pending_amount)})</div>
          </div>
          <div style={statCard}>
            <div style={{ fontSize: 12, color: '#5f6f66', marginBottom: 4 }}>Олгосон</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#16a34a' }}>{stats.paid_count} ({fmt(stats.paid_amount)})</div>
          </div>
          <div style={statCard}>
            <div style={{ fontSize: 12, color: '#5f6f66', marginBottom: 4 }}>Нийт дүн</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#236844' }}>{fmt(stats.paid_amount + stats.pending_amount)}</div>
          </div>
        </div>
      )}

      {/* Payroll table */}
      <div style={card}>
        <h3 style={{ marginBottom: 16 }}>Цалингийн жагсаалт — {period}</h3>
        {loading ? <p>Уншиж байна...</p> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                <th style={th}>Ажилтан</th>
                <th style={th}>Албан тушаал</th>
                <th style={th}>Үндсэн цалин</th>
                <th style={th}>Урамшуулал</th>
                <th style={th}>Суутгал</th>
                <th style={th}>Цэвэр дүн</th>
                <th style={th}>Статус</th>
                <th style={th}>Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              {payrolls.map((p: any) => (
                <tr key={p.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                  <td style={td}>{p.employee_name}</td>
                  <td style={td}>
                    <span style={{ background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>
                      {POSITION_LABELS[p.position] || p.position}
                    </span>
                  </td>
                  <td style={td}>{fmt(p.base_salary)}</td>
                  <td style={td}>
                    {editId === p.id ? (
                      <input type="number" value={editForm.bonus} onChange={e => setEditForm({ ...editForm, bonus: e.target.value })}
                        style={{ ...inputStyle, width: 90, padding: '4px 8px' }} />
                    ) : (
                      <span style={{ color: p.bonus > 0 ? '#16a34a' : '#999' }}>{p.bonus > 0 ? '+' + fmt(p.bonus) : '-'}</span>
                    )}
                  </td>
                  <td style={td}>
                    {editId === p.id ? (
                      <input type="number" value={editForm.deduction} onChange={e => setEditForm({ ...editForm, deduction: e.target.value })}
                        style={{ ...inputStyle, width: 90, padding: '4px 8px' }} />
                    ) : (
                      <span style={{ color: p.deduction > 0 ? '#dc2626' : '#999' }}>{p.deduction > 0 ? '-' + fmt(p.deduction) : '-'}</span>
                    )}
                  </td>
                  <td style={{ ...td, fontWeight: 700, color: '#236844' }}>{fmt(p.net_amount)}</td>
                  <td style={td}>
                    <span style={{
                      background: p.status === 'paid' ? '#dcfce7' : p.status === 'cancelled' ? '#fee2e2' : '#fef9c3',
                      color: p.status === 'paid' ? '#16a34a' : p.status === 'cancelled' ? '#dc2626' : '#92400e',
                      padding: '2px 8px', borderRadius: 4, fontSize: 12,
                    }}>{STATUS_LABELS[p.status] || p.status}</span>
                    {p.paid_at && <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>
                      {new Date(p.paid_at).toLocaleDateString()} · {METHOD_LABELS[p.payment_method] || p.payment_method}
                    </div>}
                  </td>
                  <td style={td}>
                    {p.status === 'paid' && (
                      <button onClick={() => handleUnpay(p.id)} style={{ ...btnSmall, background: '#fef3c7', color: '#92400e' }} title="Санамсаргүй олгосон гэж тэмдэглэсэн бол буцаана">Олголт буцаах</button>
                    )}
                    {p.status === 'pending' && (
                      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        {editId === p.id ? (
                          <>
                            <button onClick={handleEditSave} style={{ ...btnSmall, background: '#dcfce7', color: '#16a34a' }}>Хадгалах</button>
                            <button onClick={() => setEditId(null)} style={btnSmall}>Болих</button>
                          </>
                        ) : (
                          <>
                            <button onClick={() => startEdit(p)} style={btnSmall}>Засах</button>
                            <button onClick={() => handlePay(p.id, 'bank_transfer')} style={{ ...btnSmall, background: '#dcfce7', color: '#16a34a' }}>Банк</button>
                            <button onClick={() => handlePay(p.id, 'cash')} style={{ ...btnSmall, background: '#e0f2fe', color: '#0369a1' }}>Бэлэн</button>
                            <button onClick={() => handleCancel(p.id)} style={{ ...btnSmall, background: '#fee2e2', color: '#dc2626' }}>Цуцлах</button>
                          </>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
              {payrolls.length === 0 && (
                <tr><td colSpan={8} style={{ ...td, textAlign: 'center', color: '#999' }}>
                  {period} сард цалингийн бүртгэл байхгүй. "Цалин үүсгэх" товч дарна уу.
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const btnSecondary: React.CSSProperties = {
  background: '#e8e5dc', color: '#2a3b32', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14,
};
const btnSmall: React.CSSProperties = {
  background: '#f0efea', color: '#2a3b32', border: 'none', padding: '4px 10px',
  borderRadius: 6, cursor: 'pointer', fontSize: 12,
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 16,
};
const statCard: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
